/* eslint-disable @typescript-eslint/no-explicit-any */
import Intercom from "@intercom/messenger-js-sdk";
import { useEffect, useState } from "react";
import { LuSparkles } from "react-icons/lu";
import { useMatch, useNavigate } from "react-router-dom";
import {
  AppShell,
  Avatar,
  Burger,
  Button,
  Divider,
  Flex,
  Group,
  Image,
  Menu,
  NavLink,
  ScrollArea,
  Text,
  Title,
  rem,
} from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import {
  IconArrowUpRight,
  IconChevronDown,
  IconChevronUp,
  IconClipboardList,
  IconHomeFilled,
  IconLogout,
  IconMicrophoneFilled,
  IconMoneybag,
  IconPawFilled,
  IconPlugConnected,
  IconSettings,
  IconUser,
} from "@tabler/icons-react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import {
  FetchUserAttributesOutput,
  fetchAuthSession,
  fetchUserAttributes,
} from "aws-amplify/auth";
import { getUrl } from "aws-amplify/storage";
import { useUserProvider } from "@/utils/UserProvider";
import mantaClassicLogo from "../assets/Manta_Classic_appicon.png";
import CopyRight from "./Copyright";
import { LinksGroup } from "./LinkGroup/LinksGroup";
import NavbarFreeTrialSection from "./NavbarFreeTrialSection";
import DeleteAccountModal from "./Profile/DeleteAccountModal";
import RouteSwitcher from "./RouterSwitcher";

export default function Navbar() {
  const [opened, { toggle }] = useDisclosure();
  const navigate = useNavigate();
  const { resetData } = useUserProvider();
  // retrieves only the current value of 'user' from 'useAuthenticator'
  const userSelector = (context: any) => [context.user];
  const { signOut } = useAuthenticator(userSelector);
  const [profileImage, setProfileImage] = useState<any>();
  const [openedDeleteAccountModal, setOpenedDeleteAccountModal] =
    useState<boolean>(false);
  const [profile, setProfile] = useState<any>();
  useEffect(() => {
    fetchData();
  }, []);
  const isMobile = useMediaQuery("(max-width: 50em)");
  const settingMenu = {
    label: "Settings",
    icon: IconSettings,
    // links: [
              //   { label: "Terms of Use", link: "https://classic.manta.app/terms-of-use" },
              //   { label: "Privacy Policy", link: "https://classic.manta.app/privacy" }
    // ]
  };

  useEffect(() => {
    setUpIntercom();
  }, []);

  const setUpIntercom = async () => {
    const userId = (await fetchAuthSession()).userSub;
    const userInfo: FetchUserAttributesOutput = await fetchUserAttributes();

    Intercom({
      app_id: "g08upp35",
      user_id: userId, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
      name: userInfo.name, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
      email: userInfo.email, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
      // created_at: amplifyUser.createdAt, // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
    });
  };

  const fetchData = async () => {
    const userInfo: FetchUserAttributesOutput | any =
      await fetchUserAttributes();
    setProfile(userInfo);

    const identityId = (await fetchAuthSession()).identityId;
    if (userInfo.picture) {
      // const s3Image = await Storage.get(userInfo.picture, { level: 'private' });
      const s3Image = (
        await getUrl({
          path: `private/${identityId}/${userInfo.picture}`,
          options: { validateObjectExistence: true },
        })
      ).url.toString();

      setProfileImage(s3Image);
    } else {
      // const s3Image = await Storage.get('pet-image-placeholder.png', { level: 'public' });
      const s3Image = (
        await getUrl({
          path: "public/pet-image-placeholder.png",
          options: { validateObjectExistence: true },
        })
      ).url.toString();
      setProfileImage(s3Image);
    }
  };

  const handleLogout = async () => {
    await resetData();
    signOut();
  };

  const newMantaBannerHeight = isMobile ? 84 : 44;

  return (
    <AppShell
      header={{ height: newMantaBannerHeight + 60 }}
      navbar={{ width: 260, breakpoint: "sm", collapsed: { mobile: !opened } }}
      footer={{ height: isMobile ? 60 : 0 }}
      padding="md"
    >
      {true && (
        <AppShell.Header>
          <Flex
            align="center"
            justify="center"
            direction={isMobile ? "column" : "row"}
            gap={isMobile ? 6 : "md"}
            style={{
              minHeight: newMantaBannerHeight,
              padding: isMobile ? "10px 16px" : "6px 20px",
              background:
                "linear-gradient(90deg, #003554 0%, #004b75 52%, #006494 100%)",
              color: "white",
              textAlign: "center",
            }}
          >
            <Text size={isMobile ? "xs" : "sm"} fw={600} lh={1.35}>
              A better Manta is ready for you. Faster workflows, cleaner notes,
              same trusted care.
            </Text>
            <Button
              component="a"
              href="https://go.manta.app"
              target="_blank"
              rel="noopener noreferrer"
              size="xs"
              radius="xl"
              variant="white"
              color="manta"
              rightSection={<IconArrowUpRight size={14} />}
            >
              Try it now
            </Button>
          </Flex>
          {/* <Group h="100%" px="md">
                    <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
                </Group> */}
          {/* OR */}
          <Flex
            justify="space-between"
            align="center"
            style={{ padding: "10px 20px" }}
          >
            <Burger
              opened={opened}
              onClick={toggle}
              hiddenFrom="sm"
              size="sm"
            />

            <Group>
              <Button p={0} h={40} w={40} bd={0} onClick={() => navigate("/")}>
                <Image
                  src={mantaClassicLogo}
                  h={40}
                  w="auto"
                  fit="contain"
                  radius="md"
                />
              </Button>
              <Title size="xl">Manta Classic</Title>
              {/* <ActionIcon variant="subtle" onClick={() => navigate("/?product_tour_id=604703")}><IconHelp color="blue" size={20} /></ActionIcon> */}
            </Group>

            {/* <Button
              size="sm"
              variant="link"
              onClick={() => {
                window.location.replace("https://classic.manta.app");
              }}
            >
              V1 Interface
              <IconArrowUpRight size={"18"} />
            </Button>  */}
          </Flex>
        </AppShell.Header>
      )}
      <AppShell.Navbar p="md" withBorder={true} color="manta">
        {false && (
          <AppShell.Section>
            <Flex direction="row" justify="flex-start" align="center">
              <Burger
                opened={opened}
                onClick={toggle}
                hiddenFrom="sm"
                size="sm"
              />
              <Image
                src={mantaClassicLogo}
                h={30}
                w="auto"
                fit="contain"
                radius="md"
              />
              <Text style={{ marginLeft: 5 }}>Manta Classic</Text>
            </Flex>
            <Divider my="sm" />
          </AppShell.Section>
        )}

        <AppShell.Section grow component={ScrollArea}>
          <NavLink
            label="Dashboard"
            leftSection={<IconHomeFilled size="1rem" stroke={1.5} />}
            onClick={() => {
              toggle();
              navigate("/");
            }}
            variant="filled"
            active={useMatch("/") === null ? false : true}
          />
          <NavLink
            label="Quick record"
            leftSection={<IconMicrophoneFilled size="1rem" stroke={1.5} />}
            onClick={() => {
              toggle();
              navigate("/quick-record");
            }}
            variant="filled"
            // color='blue'
            active={useMatch("/quick-record") === null ? false : true}
          />
          <NavLink
            label="Patients"
            leftSection={<IconPawFilled size="1rem" stroke={1.5} />}
            onClick={() => {
              toggle();
              navigate("/patients");
            }}
            variant="filled"
            // color='blue'
            active={useMatch("/patients") === null ? false : true}
          />
          <NavLink
            label="Templates"
            leftSection={<IconClipboardList size="1rem" stroke={1.5} />}
            onClick={() => {
              toggle();
              navigate("/templates");
            }}
            variant="filled"
            // color='blue'
            active={useMatch("/templates") === null ? false : true}
          />
          <NavLink
            label="Integrations"
            // rightSection={<Pill>Coming soon</Pill>}
            leftSection={<IconPlugConnected size="1rem" stroke={1.5} />}
            onClick={() => {
              toggle();
              navigate("/integrations");
            }}
            variant="filled"
            // color='blue'
            active={useMatch("/integrations") === null ? false : true}
          />
          <LinksGroup {...settingMenu} toggleMenu={toggle} />
          {/* <NavLink
            label="Help"
            leftSection={<IconHelp size="1rem" stroke={1.5} />}
            onClick={() => {
              toggle();
              // navigate("/integrations");
              if (typeof window.Intercom === "function") {
                window.Intercom("show");
              }
            }}
            variant="filled"
            // color='blue'
            active={useMatch("/help") === null ? false : true}
          /> */}
        </AppShell.Section>
        <NavbarFreeTrialSection />
        {/* <NavbarRecordsChallengeSection /> */}
        <AppShell.Section>
          <NavLink
            label="Refer friends, get $500"
            onClick={() => {
              toggle();
              navigate("/referral-link");
            }}
            variant="filled"
            active={useMatch("/referral-link") === null ? false : true}
          />
        </AppShell.Section>
        <AppShell>
          <Menu
            withArrow
            width={300}
            position={isMobile ? "top-end" : "right"}
            transitionProps={{ transition: "pop" }}
            withinPortal
            closeDelay={400}
            trigger="hover"
          >
            <Menu.Target>
              <Group flex={1} className="cursor-pointer" mt={10}>
                <Avatar
                  src={profileImage}
                  radius="xl"
                  onClick={() => {
                    navigate("/billing");
                  }}
                />
                <div style={{ flex: 1 }}>
                  <Text size="sm" fw={500}>
                    {profile?.name}
                  </Text>

                  <Text c="dimmed" size="xs">
                    {profile?.email}
                  </Text>
                </div>

                <Flex direction={"column"} id="box-icon-profile">
                  <IconChevronUp
                    className="icon-up icon"
                    style={{ width: rem(14), height: rem(14) }}
                    stroke={1.5}
                  />
                  <IconChevronDown
                    className="icon-down icon"
                    style={{ width: rem(14), height: rem(14) }}
                    stroke={1.5}
                  />
                </Flex>
              </Group>
            </Menu.Target>
            <Menu.Dropdown>
              <Group
                flex={1}
                className="cursor-pointer"
                mt={10}
                ml={10}
                mb={10}
              >
                <Avatar
                  src={profileImage}
                  radius="xl"
                  onClick={() => {
                    navigate("/settings/account");
                  }}
                />
                <div style={{ flex: 1 }}>
                  <Text size="sm" fw={500}>
                    {profile?.name}
                  </Text>

                  <Text c="dimmed" size="xs">
                    {profile?.email}
                  </Text>
                </div>
              </Group>
              <Divider m={0} />
              <Menu.Item
                leftSection={<LuSparkles size="1rem" />}
                onClick={() => {
                  toggle();
                  navigate("/plans");
                }}
                variant="filled"
              >
                Upgrade to Premium
              </Menu.Item>
              <Divider />
              <Menu.Item
                leftSection={<IconUser size="1rem" stroke={1.5} />}
                onClick={() => {
                  toggle();
                  navigate("/settings");
                }}
                variant="filled"
              >
                Account
              </Menu.Item>
              <Menu.Item
                leftSection={<IconMoneybag size="1rem" stroke={1.5} />}
                onClick={() => {
                  toggle();
                  navigate("/billing");
                }}
                variant="filled"
              >
                Billing
              </Menu.Item>
              <Divider m={0} />
              <Menu.Item
                leftSection={
                  <IconLogout
                    style={{ width: rem(16), height: rem(16) }}
                    stroke={1.5}
                  />
                }
                onClick={handleLogout}
              >
                Logout
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </AppShell>
      </AppShell.Navbar>
      <AppShell.Main>
        <RouteSwitcher />
      </AppShell.Main>
      {/* <AppShell.Aside>Test</AppShell.Aside> */}
      {isMobile && (
        <AppShell.Footer>
          <CopyRight />
        </AppShell.Footer>
      )}
      <DeleteAccountModal
        modalOpened={openedDeleteAccountModal}
        setModalOpened={setOpenedDeleteAccountModal}
      />
    </AppShell>
  );
}
